import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function removeCookie(Cookie) {
  return Cookies.remove(Cookie)
}
export function getCookie(Cookie) {
  return Cookies.get(Cookie)
}
